import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import { IconButton } from '../../../../../packages/ui/molecules/icon-button';
import {
  fontWeight,
  Heading,
  headingLevel,
  Text,
  TextError,
} from '../../../../../packages/ui/atoms/typography';
import { Button, btnType } from '../../../../../packages/ui/atoms/button';
import { Textarea } from '../../../../../packages/ui/atoms/textarea';

import { useStyles } from '../../../../../pages/provider/profile/components/general-info/GeneralInfo.styles';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../../redux/modules/snackbar';

const PatientSummary = ({ isOpen, onClose, patientSummary, onSubmit }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [savingButton, setSavingButton] = useState(false);
  const [values, setValues] = useState('');

  useEffect(() => {
    setValues(patientSummary);
  }, [patientSummary]);

  return (
    <Drawer open={isOpen} onClose={onClose} variant={drawerType.NORMAL} className={classes.drawer}>
      <Box className={classes.wrapper}>
        <Box className={classes.header}>
          <Text className={classes.headerTitle}>Edit patient summary</Text>
          <IconButton icon="close" onClick={onClose} className={classes.backBtn} />
        </Box>

        <Box className={classes.formContent}>
          <Box className={classes.section}>
            <Heading level={headingLevel.S} className={classes.label} weight={fontWeight.BOLD}>
              Patient Summary
            </Heading>
            <Textarea
              value={values}
              name="patientSummary"
              onChange={e => setValues(e.target.value)}
              // onBlur={setTouched('description')}
              minRows={5}
              placeholder="Enter patient summary"
            />
          </Box>
        </Box>
        <Box className={classes.footer}>
          <Button variant={btnType.TEXT} onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (values) {
                setSavingButton(true);
                onSubmit(values);
                setSavingButton(false);
                setValues('');
                onClose();
              } else {
                dispatch(
                  showSnackbar({
                    snackMessage: 'Please enter patient summary',
                    snackType: 'error',
                  }),
                );
              }
            }}
            disabled={savingButton}
          >
            {savingButton ? 'Saving...' : 'Update'}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export { PatientSummary };
